var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sip-image-upload" },
    [
      !_vm.disabledInput
        ? _c("file-dropzone", {
            ref: "dropzone",
            attrs: {
              id: _vm.id,
              "button-text": _vm.buttonText,
              accept: ".jpg,.jpeg,.png,.gif,.pdf,image/*",
              "existing-preview": _vm.dropzonePreview,
              "existing-name": _vm.existingLabel,
            },
            on: { change: _vm.previewImage },
          })
        : _vm.dropzonePreview
        ? _c(
            "div",
            { staticClass: "sip-file-dropzone sip-file-dropzone--readonly" },
            [
              _c("div", { staticClass: "sip-file-dropzone__body" }, [
                _c("div", { staticClass: "sip-file-dropzone__thumb" }, [
                  _c("img", {
                    attrs: { src: _vm.dropzonePreview, alt: "" },
                    on: { error: _vm.onImageError },
                  }),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.imageLoadError
        ? _c("p", { staticClass: "text-soft small mt-2" }, [
            _vm._v(
              _vm._s(
                _vm.trans("general.image_load_failed") ||
                  "Image could not be loaded."
              )
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isPdfCurrent
        ? _c("div", { staticClass: "sip-image-upload__pdf" }, [
            _c("a", { attrs: { target: "_blank", href: _vm.pdfHref } }, [
              _vm._v(_vm._s(_vm.trans("general.view"))),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.disabledInput
        ? _c("div", { staticClass: "sip-image-upload__actions" }, [
            _vm.defaultImage && !_vm.source
              ? _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "confirm",
                        rawName: "v-confirm",
                        value: { ok: _vm.confirmRemove(_vm.imageSource) },
                        expression: "{ok: confirmRemove(imageSource)}",
                      },
                    ],
                    staticClass: "btn btn-sm btn-danger",
                    attrs: { type: "button" },
                  },
                  [_vm._v(_vm._s(_vm.trans("general.remove")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.source
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-primary",
                    attrs: { type: "button" },
                    on: { click: _vm.uploadImage },
                  },
                  [_vm._v(_vm._s(_vm.trans("general.upload")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.source
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-danger",
                    attrs: { type: "button" },
                    on: { click: _vm.cancelUploadImage },
                  },
                  [_vm._v(_vm._s(_vm.trans("general.cancel_upload")))]
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }